var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.7 174.6",
    style: {
      enableBackground: "new 0 0 146.7 174.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:none;stroke:#FCAD9A;stroke-width:3;stroke-linecap:round;}\r\n    .st1{fill:#2163FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    transform: "translate(-740.529 -3998.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    className: "st0",
    d: "M875.2,4143.5c7.8-59.8-118.9-64.1-125.8-127"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    transform: "translate(879.757 4150.649) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    className: "st1",
    cx: -3994.1,
    cy: 744.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    className: "st1",
    cx: -3980.1,
    cy: 744.5,
    r: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern3);
export default __webpack_public_path__ + "static/media/pattern3.6d260581.svg";
export { ForwardRef as ReactComponent };